import React, { useEffect } from "react";
import { useCountUp } from "../../hooks/useCountUp";
import { useInView } from "../../hooks/useInView";

const STATS = [
  { display: "5 signals", label: "Fit, freshness, callback odds, company health, hiring volatility", countUp: false },
  { display: "3 free", label: "Analyses every month. No credit card.", countUp: false },
  { target: 30, prefix: "< ", suffix: " seconds", label: "Typical time to your GuMi report", countUp: true },
];

export const StatsBar = () => {
  const { ref, inView } = useInView(0.3);

  return (
    <section
      ref={ref}
      data-testid="stats-bar-section"
      style={{ background: "#1D9E75", padding: 24, textAlign: "center" }}
    >
      <div
        className="stats-bar-row"
        style={{ maxWidth: 900, margin: "0 auto", display: "flex", justifyContent: "center" }}
      >
        {STATS.map((s, i) => (
          <React.Fragment key={s.label}>
            <Stat {...s} inView={inView} />
            {i < STATS.length - 1 && (
              <div
                className="stats-bar-divider"
                style={{ width: 1, background: "rgba(255,255,255,0.2)", margin: "4px 32px" }}
                aria-hidden="true"
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

const Stat = ({ countUp, display, target, prefix, suffix, label, inView }) => {
  return (
    <div style={{ flex: "1 1 0", minWidth: 140 }}>
      <p className="font-heading tabular" style={{ fontSize: 28, fontWeight: 700, color: "white" }}>
        {countUp ? <CountUpValue target={target} prefix={prefix} suffix={suffix} inView={inView} /> : (
          <span
            style={{
              opacity: inView ? 1 : 0,
              transition: "opacity 0.6s cubic-bezier(0.16,1,0.3,1)",
            }}
          >
            {display}
          </span>
        )}
      </p>
      <p className="font-body" style={{ fontSize: 12, color: "rgba(255,255,255,0.7)", marginTop: 2 }}>
        {label}
      </p>
    </div>
  );
};

// The "< 30 seconds" stat: count 0 -> 30 over 800ms, then reveal the "< "
// prefix / " seconds" suffix once the count has landed.
const CountUpValue = ({ target, prefix, suffix, inView }) => {
  const { count, start } = useCountUp(target, 800, false);

  useEffect(() => {
    if (inView) start();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const done = count >= target;

  return (
    <>
      {done ? prefix : ""}
      {count}
      {done ? suffix : ""}
    </>
  );
};

export default StatsBar;
